import React from "react";

const GoogleMaps = React.createContext(null)

class GoogleMapsContext extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            loaded: false,
            apiKey: this.props.apiKey
        }
        this.loadMapsApi()
    }

    loaded(){
        this.setState({
            loaded: true
        })
    }

    async loadMapsApi(){
        const url = `https://maps.googleapis.com/maps/api/js?key=${this.props.apiKey}&libraries=places`
        if (document.head.querySelector(`script[src="${url}"]`)){
            this.loaded()
        }
        const script = document.createElement("script")
        script.src = url
        script.addEventListener('load', this.loaded.bind(this))
        document.head.appendChild(script)
    }

    render(){
        return (
            <GoogleMaps.Provider value={this.state}>
                {this.props.children}
            </GoogleMaps.Provider>
        )
    }
}

export {GoogleMaps, GoogleMapsContext}